<template>
  <div class="layer">
    <div>
      <img class="logo" src="static/img/logo2022.png" />
    </div>
    <div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="ruleForm.userName" disabled=""></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="name" >
          <el-input v-model="ruleForm.name" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email" >
          <el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone" >
          <el-input v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code" class="code" >
          <el-input v-model="ruleForm.code" placeholder="请输入验证码"></el-input>
          <el-button type="primary" @click="getCode" :disabled="isCode" :loading='loading'>{{codeTxt}}</el-button>
        </el-form-item>
        <el-form-item label="所属身份" >
          <el-select v-model="ruleForm.region" placeholder="请选择省份">
            <el-option v-for="item in provinceList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: center;">
          <el-button type="primary" @click="submitForm('ruleForm')">完善资料</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getCode } from '@/api/registered'
import { getPro } from '@/api/common'
export default {
  name: 'registered',
  data () {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      ruleForm: {
        userName: '',
        name: '',
        email: '',
        phone: '',
        code: '',
        province: ''
      },
      rules: {
        userName: [
          { required: true, message: ' ', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'change' }
        ],

        email: [
          { required: true, message: '请输入邮箱', trigger: 'change' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入正确的手机号', trigger: 'change', validator: checkPhone }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'change' }
        ]
      },
      isCode: true,
      time: 60,
      codeTxt: '获取验证码',
      loading: false,
      provinceList: [] // 省级列表
    }
  },
  mounted () {
    let data = {
      ParentId: '100000',
      PageSize: 100
    }
    getPro(data).then(res => {
      this.provinceList = res.data.Data
      console.log(res
      )
    })
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getCode () {
      this.loading = true
      this.$message.closeAll()
      let data = {
        mobile: this.ruleForm.phone
      }
      getCode(data).then(res => {
        this.loading = false
        if (res.status === 1) {
          this.$message('发送成功！')

          this.time = 60
          this.isCode = true
          this.timer()
        } else if (res.status === 1) {
          this.$message('手机号关联账户已存在，如您选择继续，则将更新您的账户信息!')
        }
      })
    },
    // 60S倒计时
    timer () {
      if (this.time > 0) {
        this.time--
        this.codeTxt = this.time + 's后重新获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.codeTxt = '重新获取'
        this.isCode = false
      }
    }

  },
  watch: {
    ruleForm: {
      deep: true,
      handler (val) {
        const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
        if (reg.test(val.phone)) {
          this.isCode = false
        } else {
          this.isCode = true
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.layer {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo {
    margin-top: 4vh;
    width: 35vw;
    min-width: 200px;
  }
  .el-form{
    margin-top: 4vh;
    width: 20vw;
    min-width: 400px;
    .el-select{
      width: 100%;
    }
    .code{
      .el-form-item__content{
        display: flex;
        flex-direction: row;
        .el-button{
          margin-left: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/registered/registered.vue